<template>
	<div class="" style="position: relative; height: 100vh;">
		<!-- 客服电话区域（加背景底色，防重叠） -->
		<div style="position: absolute; left: 50px; top: 50%; transform: translateY(-50%); z-index: 10; max-width: 500px; 
			background: rgba(255, 255, 255, 0.9); padding: 40px 30px; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);">
			<div style="font-size: 30px; color: #222; font-weight: 700; margin-bottom: 20px;">省拼达客服支持</div>
			<div style="font-size: 18px; color: #666; line-height: 1.6; margin-bottom: 24px;">
				如在使用相关产品过程中遇到任何问题，<br/>
				请随时联系我们，我们会尽快为您解决。
			</div>
			<div style="font-size: 36px; color: #0066cc; font-weight: 700; letter-spacing: 2px;">13435793731</div>
		</div>

		<!-- 右侧图片 -->
		<div class="" style="position: absolute;right: 0; height: 100%;">
			<img src="../../assets/guanyu.png" style="object-fit: cover;height: 100%;" />
		</div>

		<!-- 底部备案信息 -->
		<div
			style="position: fixed;bottom: 0px;left:0;right:0;text-align:center;background: rgba(0, 0, 0, 0.5);padding: 8px;color: white;">
			<a href="http://beian.miit.gov.cn" target="_blank" style="color: white;">粤ICP备2023143355号</a>
			<span> | 省拼达 版权所有 ©2025</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Dashboard',
	components: {},
	methods: {}
}
</script>

<style scoped></style>